module.exports = {
	"id": "LR",
	"name": "Liberia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.01145,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.00229,
			"9": null,
			"10": 0.00458,
			"11": 0.02519,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": 0.00229,
			"20": 0.00458,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.01145,
			"27": null,
			"28": 0.00458,
			"29": 0.01145,
			"30": 0.00229,
			"31": 0.00687,
			"32": 0.00458,
			"33": 0.05954,
			"34": 0.00687,
			"35": 0.00458,
			"36": 0.00687,
			"37": 0.00458,
			"38": 0.00458,
			"39": 0.05954,
			"40": 0.06641,
			"41": 0.00229,
			"42": 0.00916,
			"43": 0.1374,
			"44": 0.00916,
			"45": 0.03893,
			"46": 0.00916,
			"47": 0.08244,
			"48": 0.02519,
			"49": 0.5267,
			"50": 0.05496,
			"51": 0.72135,
			"52": 0.31831,
			"53": 6.32269,
			"54": 1.44041,
			"55": 0.04809,
			"56": 0.09847,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.02748,
			"4": 0.02748,
			"5": null,
			"6": 0.00458,
			"7": 0.00916,
			"8": 0.00687,
			"9": 0.00229,
			"10": 0.02061,
			"11": 0.01145,
			"12": 0.04122,
			"13": 0.02977,
			"14": 0.01145,
			"15": 0.02977,
			"16": 0.05038,
			"17": 0.02977,
			"18": 0.00687,
			"19": 0.02061,
			"20": 0.01603,
			"21": 0.03435,
			"22": 0.02519,
			"23": 0.00687,
			"24": 0.11908,
			"25": 0.00458,
			"26": 0.01374,
			"27": 0.00458,
			"28": 0.00458,
			"29": 0.03664,
			"30": 0.01374,
			"31": 0.01145,
			"32": 0.02519,
			"33": 0.03435,
			"34": 0.0229,
			"35": 0.01374,
			"36": 0.01145,
			"37": 0.05038,
			"38": 0.03664,
			"39": 0.02061,
			"40": 0.03435,
			"41": 0.04351,
			"42": 0.04351,
			"43": 0.27251,
			"44": 0.19923,
			"45": 0.0687,
			"46": 0.05954,
			"47": 0.70532,
			"48": 0.41678,
			"49": 2.52358,
			"50": 0.3435,
			"51": 0.00458,
			"52": 0.05725,
			"3.5": null,
			"3.6": 0.01603
		},
		"opera": {
			"9": null,
			"11": 0.00916,
			"12": 0.01145,
			"15": null,
			"16": null,
			"17": 0.00458,
			"18": 0.00458,
			"19": null,
			"20": 0.00687,
			"21": 0.00687,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.00687,
			"28": 0.00458,
			"29": 0.14885,
			"30": 0.00229,
			"31": null,
			"32": null,
			"33": 0.01603,
			"34": 0.01374,
			"35": 0.00916,
			"36": 0.01145,
			"37": 0.21297,
			"38": 0.01832,
			"39": 0.04809,
			"40": 0.46487,
			"41": 0.05038,
			"42": null,
			"43": null,
			"9.5-9.6": 0.00458,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.00458,
			"11.1": null,
			"11.5": 0.00229,
			"11.6": 0.03893,
			"12.1": 0.02519
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.00687,
			"6": 0.00916,
			"7": 0.00687,
			"8": 0.03206,
			"9": 0.05267,
			"10": 0.25877,
			"3.1": null,
			"3.2": null,
			"5.1": 0.02748,
			"6.1": 0.02061,
			"7.1": null,
			"9.1": 0.24732
		},
		"ios_saf": {
			"8": 0,
			"10": 1.523184005,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0410480464197,
			"8.1-8.4": 0.0758345264363,
			"9.0-9.2": 0.0361779392173,
			"9.3": 0.551945482931
		},
		"android": {
			"3": 0,
			"4": 0.236240775194,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0295300968992,
			"4.1": 0.852154224806,
			"4.2-4.3": 2.13038556202,
			"4.4": 4.88512174419,
			"4.4.3-4.4.4": 4.9273075969
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.43052,
			"9": 0.12137,
			"10": 0.28854,
			"11": 1.61445,
			"5.5": null
		},
		"op_mob": {
			"0": 1.83596698788,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0509990829967
		},
		"edge": {
			"12": 0.22213,
			"13": 0.23358,
			"14": 0.23129
		},
		"ie_mob": {
			"10": 0.161149859155,
			"11": 0.656110140845
		},
		"bb": {
			"7": 0.0173475,
			"10": null
		},
		"samsung": {
			"0": 1.60368
		},
		"and_uc": {
			"0": 7.43244
		},
		"op_mini": {
			"0": 24.7356639291
		},
		"and_chr": {
			"0": 26.45767
		},
		"and_ff": {
			"0": 0.01542
		}
	},
	"total": 98.9592675
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/LR.json
 ** module id = 576
 ** module chunks = 0
 **/